import React, { createContext, useState, useEffect } from 'react';
import axios from "axios";
import { useLocalStorage } from '../../hooks/useLocalStorage';

export const DataContext = createContext();


export const DataProvider = ({ children }) => {

  //Hooks API get return
  const dolarBase = "https://api.bluelytics.com.ar/v2/latest"
  const baseImage = "https://72jjtpdj.directus.app/assets/";
  const baseURLCategorias = "https://72jjtpdj.directus.app/items/categorias?limit=-1";
  const baseURLProductos = "https://72jjtpdj.directus.app/items/productos?&sort=-date_created&?limit=-1";
  const baseURLHeroSlider = "https://72jjtpdj.directus.app/items/HeroSlider";
  const baseURLLogoSlider = "https://72jjtpdj.directus.app/items/LogosSlider";


  //Hooks Array Return
  const [idProductModal, setIdProductModal] = useState([]);
  const [heroSliderCategorias, setHeroSliderCategorias] = useState([]);
  const [heroSlider, setHeroSlider] = useState([]);
  const [productos, setProductos] = useState([]);
  const [logoSlider, setLogoSlider] = useState([]);
  const [precioValue, setPrecioValue] = useState([]);
  const [listaProductos, setListaProductos] = useState([]);
  const [categoria, setCategoria] = useState([]);

  //Hooks Boolean Return
  const [errorDolarAPI, setErrorDolarAPI] = useState(false);
  const [isSelected, setIsSelected] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [changeRenderProductSelected, setChangeRenderProductSelected] = useState(false);

  //Hoorks number and string return
  const [count, setCount] = useState(1);
  const [idProduct,setIdProduct] = useState(0);
  const [inputSearch, setInputSearch] = useState("");
  const [idProductView, setIdProductView] = useState("");
  const [CartItem, setCartItem] = useLocalStorage('CARTLIST_V1', []);


  //Funciones Get info APIS
  const getCategorias = () => {
    axios.get(baseURLCategorias).then((response) => {
      setCategoria(response.data.data)
    });

    axios.get(baseURLCategorias).then((response) => {
 
      setCategoria(response.data.data)
    });
  }

  const getImagesSliders = () => {
    axios.get(baseURLHeroSlider).then((response) => {
      setHeroSlider(response.data.data);
    });
  }

  const getLogosSlider = () => {
    axios.get(baseURLLogoSlider).then((response) => {
      setLogoSlider(response.data.data);
    });
  }

  const getProducts = () => {
    axios.get(baseURLProductos).then((response) => {
      setProductos(response.data.data);
    });
  }

  const getDolarAPI = () => {
    axios.get(dolarBase, {
      headers: {
        crossorigin: true
      }
    }).then((response) => {
        setPrecioValue(response.data.oficial.value_sell)
    }).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log("Error Code:",error.response.status);
        console.log(error.response.headers);
        setErrorDolarAPI(true);
        setPrecioValue(1)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    })
  }

  //useEffect API JSON Return
  useEffect(() => {
    getCategorias();
    getImagesSliders();
    getLogosSlider();
    getProducts();
    getDolarAPI();
  }, []);


  return (
    <DataContext.Provider value={{
      setInputSearch,
      inputSearch,
      openModal,
      setOpenModal,
      dolarBase,
      precioValue,
      heroSliderCategorias,
      heroSlider,
      baseImage,
      setChangeRenderProductSelected,
      changeRenderProductSelected,
      setListaProductos,
      listaProductos,
      setCartItem,
      CartItem,
      setCount,
      count,
      setIsSelected,
      isSelected,
      setIdProduct,
      idProduct,
      setIdProductModal,
      idProductModal,
      setIdProductView,
      idProductView,
      logoSlider,
      errorDolarAPI,
      productos,
      categoria
    }}>
      {children}
    </DataContext.Provider>
  )
}
